// extracted by mini-css-extract-plugin
export default {"image":"Banners_image__2gb11","slider":"Banners_slider__GCx9e"};